import { useStaleCacheBanner } from '../hooks/useStaleCacheBanner';
import styles from './StaleCacheBanner.module.css';

function humanizeAge(ms: number): string {
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes === 1) return '1 minute ago';
  if (minutes < 60) return `${minutes} minutes ago`;
  const hours = Math.floor(minutes / 60);
  if (hours === 1) return '1 hour ago';
  if (hours < 24) return `${hours} hours ago`;
  const days = Math.floor(hours / 24);
  return days === 1 ? '1 day ago' : `${days} days ago`;
}

export function StaleCacheBanner() {
  const { isStale, oldestAgeMs, dismiss } = useStaleCacheBanner();
  if (!isStale) return null;

  const ageLabel = oldestAgeMs != null ? humanizeAge(oldestAgeMs) : 'just now';

  const handleReconnect = () => {
    if (typeof navigator !== 'undefined' && navigator.onLine) {
      window.location.reload();
    } else {
      dismiss();
    }
  };

  return (
    <div class={styles.banner} role="status" aria-live="polite">
      <span class={styles.text}>Showing offline content — last updated {ageLabel}.</span>
      <button type="button" class={styles.action} onClick={handleReconnect}>
        Reconnect
      </button>
      <button
        type="button"
        class={styles.dismiss}
        onClick={dismiss}
        aria-label="Dismiss offline notice"
      >
        ×
      </button>
    </div>
  );
}
